import { Box, Typography } from '@mui/material';
import Head from 'next/head';

const BRAND_TITLE = 'Cornerstone Upstream';
const HEADING_TAGS = new Set(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']);

export default function PageTitle(props) {
  const { title, headTitle, subtitle, variant = 'h3', unshownTitle } = props;
  const prefix = title || headTitle;
  const computedHeadTitle = prefix ? `${prefix} | ${BRAND_TITLE}` : BRAND_TITLE;

  // Only render semantic heading tags as the underlying element
  const headingTag = HEADING_TAGS.has(variant) ? variant : 'h3';

  return (
    <>
      <Head>
        <title>{unshownTitle ?? computedHeadTitle}</title>
      </Head>
      <Box>
        {title && (
          <Typography variant={headingTag} component={headingTag}>
            {title}
          </Typography>
        )}
        {subtitle && (
          <Typography variant='subtitle1' component='p'>
            {subtitle}
          </Typography>
        )}
      </Box>
    </>
  );
}
